import {DatePicker, Form, Input} from "antd";
import {WdiInputNumber} from "@/components/WdiControls/WdiInputNumber";

const activityDate = (props: any) => (
  <Form.Item name="activityDate" label="活动期间">
    <DatePicker.RangePicker format={'YYYY-MM-DD'}/>
  </Form.Item>
);
const supplyDate = (props: any) => (
  <Form.Item name="supplyDate" label="供货期间">
    <DatePicker.RangePicker format={'YYYY-MM-DD'}/>
  </Form.Item>
);

const remark = (props: any) => (
  <Form.Item name="remark" label="备注">
    <Input maxLength={2000}/>
  </Form.Item>
);
const roiForecast = (props: any) => (
  <Form.Item name="roiForecast" label="预计费比" rules={[{required: true, message: "预计费比不能为空"}]}>
    <WdiInputNumber format={"p"} readOnly/>
  </Form.Item>
);
const ecName = (props: any) => (
  <Form.Item name="ecName" label="费用项">
    <Input readOnly/>
  </Form.Item>
);
const revenueTypeName = (props: any) => (
  <Form.Item name="revenueTypeName" label="核算类型">
    <Input readOnly/>
  </Form.Item>
);
const boNames = (props: any) => (
  <Form.Item name="boNames" label="使用部门">
    <Input readOnly/>
  </Form.Item>
);
const custType = (props: any) => (
  <Form.Item name="custType" label="客户分类">
    <Input readOnly/>
  </Form.Item>
);
const custSys = (props: any) => (
  <Form.Item name="custSys" label="客户组">
    <Input readOnly/>
  </Form.Item>
);
const soldToRealNames = (props: any) => (
  <Form.Item name="soldToRealNames" label="ERP客户">
    <Input readOnly/>
  </Form.Item>
);
const shipToNames = (props: any) => (
  <Form.Item name="shipToNames" label="收货地">
    <Input readOnly/>
  </Form.Item>
);

const fieldItems: Record<string, (props?: any) => React.ReactElement> = {
  "activityDate": activityDate,
  "supplyDate": supplyDate,
  "remark": remark,
  "roiForecast": roiForecast,
  "ecName": ecName,
  "revenueTypeName": revenueTypeName,
  "boNames": boNames,
  "custType": custType,
  "custSys": custSys,
  "soldToRealNames": soldToRealNames,
  "shipToNames": shipToNames,
};

export const buildFormItem = (key: string, props?: any) => {
  return fieldItems[key](props);
}

export const getPdDetailPrevField = (formSaDetail: API.FormSaDetail) => {
  return {
    ecId: formSaDetail.ecId,
    revenueType: formSaDetail.revenueType,
  }
};
